export default "__VITE_ASSET__CKT1ILqB__"